<template>
  <div>
    <md-dialog
      v-model="errorVisible"
      :closable="false"
      :btns="btns"
    >
      {{ message }}
    </md-dialog>
  </div>
</template>

<script>
import { Dialog } from 'mand-mobile'
import { mapMutations } from 'vuex'
export default {
  name: 'ErrorDialog',
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      btns: [
        {
          text: this.$t('i_know'),
          handler: this.onBasicConfirm
        }
      ],
      message: ''
    }
  },
  computed: {
    errorVisible: {
      get () {
        return this.$store.state.errorVisible
      },
      set () {}
    }
  },
  updated () {
    if (!this.message) {
      // HACK 判断为完成
      const { accountStatus, userStatus } = this.$store.getters
      // 用户状态异常
      if (userStatus !== 1) {
        this.message = this.$t('user_status_error') // 用户状态异常，请检查后重试！
      }
      // 账户状态
      if (accountStatus) {
        this.message = this.$t('account_status_error') // 账户状态异常，请检查后重试！
      }
      // 用户状态异常 账户状态
      if (userStatus !== 1 && accountStatus) {
        this.message = this.$t('user_status_error')
      }
    }
  },
  methods: {
    ...mapMutations(['change_errorVisible']),
    onBasicConfirm () { // 确认按钮
      this.change_errorVisible(false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .md-dialog-body {
  text-align: center;
  line-height: 48px;
}

::v-deep .md-dialog-content {
  border-radius: 32px;
}
</style>
